import {Transform, Type} from 'class-transformer';

import {Helper} from '../helpers/helper';

/**
 * Native file entity
 *
 * @category Common entities
 * */
export class NativeFile {
  __entity: 'WebApiFile';

  @Type(() => Object)
  @Transform(({value, obj}) => obj.binary)
  binary: File | null = null;

  lastModified: number;
  name: string;
  size: number;
  type: string;

  fileUrl?() {
    return URL.createObjectURL(this.binary);
  }

  downloadUrl?() {
    return this.fileUrl();
  }

  // @TODO redo for getters
  fileExtension?(): string {
    return ((/[.]/.exec(this.name)) ? /[^.]+$/.exec(this.name).pop() : undefined);
  }

  fileName?(): string {
    return this.name;
  }

  fileType?() {
    if (Helper.fileExt(['video']).includes(this.fileExtension())) {
      return 'video';
    }

    if (Helper.fileExt(['image']).includes(this.fileExtension())) {
      return 'image';
    }

    return 'doc';
  }

}
